import type { I18n, MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';

/**
 * Campos com controle na tela (Informações e as coleções das abas), com o rótulo do controle. O
 * Salvar do agente só aceita estas chaves (revisão !11105, B2); o resto do GET vai como veio.
 */
export const AGENT_FIELD_LABELS: Readonly<Record<string, MessageDescriptor>> = {
  name: msg`Nome`,
  categoryName: msg`Categoria do produto`,
  amortizationType: msg`Tipo de cálculo`,
  instrumentType: msg`Tipo de instrumento`,
  minimumInterestRate: msg`Taxa de Juros Mínima (%)`,
  maximumInterestRate: msg`Taxa de Juros Máxima (%)`,
  maximumBankslipOverpaymentRate: msg`Excedente máximo no boleto (%)`,
  creditProductModalityId: msg`Modalidades`,
  creditProductSubModalityId: msg`Submodalidades`,
  viewType: msg`Visibilidade do Produto`,
  numberDaysValidityCustomerRegistration: msg`Validade do cadastro (dias)`,
  cosifBankAccount: msg`Conta COSIF`,
  maximumAbsInterestPeriods: msg`Prazo máximo de carência de juros`,
  maximumAbsAmortizationPeriods: msg`Prazo máximo de carência de amortização`,
  minimumAmortizationPeriods: msg`Prazo mínimo de amortização`,
  maximumAmortizationPeriods: msg`Prazo máximo da amortização`,
  minimumPrincipalAmount: msg`Valor mínimo de emissão (R$)`,
  maximumPrincipalAmount: msg`Valor máximo de emissão (R$)`,
  minimumEmissionCostInCents: msg`Custo mínimo de emissão (R$)`,
  maximumEmissionCostInCents: msg`Custo máximo de emissão (R$)`,
  minimumEmissionCostInPercentage: msg`Custo mínimo de emissão (%)`,
  maximumEmissionCostInPercentage: msg`Custo máximo de emissão (%)`,
  maximumAutomaticLiquidationValueInCents: msg`Valor máximo para liquidação automática`,
  paymentFixedCosts: msg`Custo fixo por parcela`,
  maxIncomeCommitmentPercentage: msg`Comprometimento máx. da renda (%)`,
  requiresVehicleInspectionStep: msg`Etapa de Vistoria Veicular`,
  requiresGravameRegistrationStep: msg`Etapa de Registro de Gravame`,
  requiresUy3VehicleEngine: msg`Motor veículo UY3`,
  requiresVehicleInspectionApprovalStep: msg`Etapa de aprovação da vistoria veicular`,
  insurancePlan: msg`Plano de seguro`,
  insuranceCoverAmount: msg`Valor da cobertura do seguro`,
  insurancePercentage: msg`Percentual de Seguro`,
  termStartDate: msg`Data de início da vigência`,
  termEndDate: msg`Data final da vigência`,
  creditNotePostingDeadline: msg`Data limite de lançamento da operação`,
  cvmRegistrationNumber: msg`Número de Registro na CVM`,
  cvmRegistrationNumberIndex: msg`Sequencial de Registro na CVM`,
  cvmRegistrationDate: msg`Data de registro na CVM`,
  timeLimitToSubmitApproval: msg`Envio para aprovação`,
  timeLimitToApprove: msg`Aprovação de Compliance`,
  timeLimitToSign: msg`Assinatura`,
  timeToSendToSignatures: msg`Início das Assinaturas`,
  allowFinanceTaxExemption: msg`Permitir isenção de IOF`,
  financeFinTax: msg`Financiar IOF`,
  automaticCreditApproval: msg`Aprovação automática de limite de crédito`,
  instrumentApproval: msg`Etapa aprovação de instrumento`,
  isConsumerCreditNote: msg`Crédito Direto / Interveniente Quitante`,
  limitOpToPerson: msg`Limite de operação por pessoa`,
  manualWarranty: msg`Garantia manual`,
  openBankAccount: msg`Abrir conta transitória do devedor`,
  registerDuringReservation: msg`Registrar garantia durante etapa 'Reserva de Margem'`,
  requireGuarantor: msg`Obrigatório informar avalista`,
  requireWitness: msg`Obrigatório informar testemunhas`,
  requiresLiquidationSchedule: msg`Obrigatório uso de roteiro de liquidação`,
  shouldLiquidateInInternalBankAccount: msg`Liquidação obrigatória em conta UY3`,
  transitoryBankAccountClosure: msg`Encerrar conta transitória`,
  useCollateral: msg`Utiliza Garantia`,
  defaultCollateralDescription: msg`Descrição padrão da garantia`,
  useReleaseToPaymentTrigger: msg`Etapa de liberação para pagamento`,
  releaseToPaymentTriggerLimitInDays: msg`Período Limite para Liberar Pagamento`,
  validateBeneficiaryByCnpjRoot: msg`Validar beneficiário PJ pela raiz do CNPJ`,
  draftGeneration: msg`Gerar Contrato CCB`,
  templateDoc: msg`Caminho do Arquivo Template`,
  warrantyRegistrationOfficeDraftGeneration: msg`Gerar documento de conclusão da operação`,
  warrantyRegistrationOfficeTemplateDoc: msg`Caminho do arquivo de conclusão`,
  finishedGenerationTimelineDoc: msg`Gerar histórico da operação`,
  finishedGenerationTimelineTemplateDoc: msg`Caminho do arquivo de histórico`,
  insuranceCancellationDoc: msg`Gerar documento de cancelamento de seguro`,
  insuranceCancellationTemplateDoc: msg`Caminho do arquivo de cancelamento de seguro`,
  isBlackEndorsementGeneration: msg`Gerar documento de endosso preto`,
  blackEndorsementTemplateDoc: msg`Caminho do arquivo de endosso preto`,
  useSignaturePortal: msg`Coletar assinatura`,
  notifySigner: msg`Notificar cliente`,
  signatureType: msg`Forma de envio de Assinatura`,
  maximumValueWithoutDigitalSignature: msg`Valor máximo sem assinatura digital`,
  signaturePortalProvider: msg`Certificadora`,
  signatureValidation: msg`Tipo de Assinatura`,
  unicoTemplateName: msg`Nome template`,
  unicoMinimumScoreForSignatureValidation: msg`Score mínimo`,
  signatureValidationStep: msg`Etapa de validação de assinatura`,
  maximumValueWithoutSignatureValidation: msg`Valor mínimo para validação de assinatura`,
  partnerSignatureValidationStep: msg`Etapa de validação de assinatura pelo parceiro`,
  allowOwnFund: msg`Permite operação sem cessionário`,
  defaultFundId: msg`Cessionário padrão`,
  complianceApprovalTenantName: msg`Correspondente para aprovação do compliance`,
  liquidationApprovalTenantName: msg`Correspondente para aprovação da liquidação`,
  signatureApprovalTenantName: msg`Correspondente para aprovação da validação de assinatura`,
  warrantyRegistrationOffice: msg`Sistema de averbação`,
  payrollAgreementId: msg`Convênio de averbação`,
  creditProductCreditRulesId: msg`Selecione uma regra de crédito`,
  creditProductComplianceRulesId: msg`Selecione uma regra de compliance`,
  creditProductDynamicRulesId: msg`Selecione uma regra de dinâmica`,
  walletCode: msg`Código do convênio`,
  billingSettingId: msg`Régua de cobrança`,
  communicationSettingId: msg`Régua de comunicação`,
  relatedPerson: msg`Envolvidos`,
  requiredDoc: msg`Documentos obrigatórios`,
  signatureDocumentTemplates: msg`Documentos para Assinatura`,
  commissionRange: msg`Custo de Emissão`,
  governmentDepartments: msg`Orgão`,
};

/** Rótulos dos seletores de entidade (`displayName` dos controles); não entram na prévia. */
export const AGENT_DISPLAY_KEYS = [
  'creditProductModalityIdDisplay',
  'creditProductSubModalityIdDisplay',
  'defaultFundDisplay',
  'complianceApprovalTenantNameDisplay',
  'liquidationApprovalTenantNameDisplay',
  'signatureApprovalTenantNameDisplay',
  'payrollAgreementIdDisplay',
  'creditProductCreditRulesIdDisplay',
  'creditProductComplianceRulesIdDisplay',
  'creditProductDynamicRulesIdDisplay',
  'walletCodeDisplay',
  'billingSettingDisplay',
  'communicationSettingDisplay',
] as const;

export const AGENT_FORM_KEYS: readonly string[] = [
  ...Object.keys(AGENT_FIELD_LABELS),
  ...AGENT_DISPLAY_KEYS,
];

const same = (left: unknown, right: unknown) => JSON.stringify(left ?? null) === JSON.stringify(right ?? null);

/** Rótulos dos campos que o patch muda em relação aos valores atuais (sem valores atuais, todos). */
export function changedFieldLabels(
  i18n: I18n,
  patch: Readonly<Record<string, unknown>>,
  current?: Readonly<Record<string, unknown>>,
): string[] {
  return Object.keys(patch)
    .filter((key) => key in AGENT_FIELD_LABELS)
    .filter((key) => !current || !same(patch[key], current[key]))
    .map((key) => i18n._(AGENT_FIELD_LABELS[key] as MessageDescriptor));
}
